import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardReportRoute: InvariantJiraRoute = {
	name: 'rapidboard-report',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView',
};
